import { Col, Row } from 'antd';
import Image from 'next/image';
import styled from 'styled-components';

import banenor from '../../assets/images/LandingPage/banenor.png';
import bdo from '../../assets/images/LandingPage/bdo.png';
import bearingpoint from '../../assets/images/LandingPage/bearingpoint.png';
import ey from '../../assets/images/LandingPage/ey.png';
import farmforce from '../../assets/images/LandingPage/farmforce.png';
import handelsbanken from '../../assets/images/LandingPage/handelsbanken.png';

const BusinessCustomers = () => {
  return (
    <StyledRow gutter={[48, 32]} justify="center">
      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          <CenteredContainer>
            <Image src={ey} alt="NHH" />
          </CenteredContainer>
        </Card>
      </Col>

      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          <CenteredContainer>
            <Image src={bearingpoint} alt="BI" />
          </CenteredContainer>
        </Card>
      </Col>
      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          <CenteredContainer>
            <Image src={bdo} alt="NTNU" />
          </CenteredContainer>
        </Card>
      </Col>
      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          <CenteredContainer>
            <Image
              src={handelsbanken}
              alt="Western Norway University of Applied Sciences"
            />
          </CenteredContainer>
        </Card>
      </Col>

      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          {/* <CenteredContainer> */}
          <Image src={banenor} alt="USN" />
          {/* </CenteredContainer> */}
        </Card>
      </Col>
      <Col xs={24} md={12} lg={8} xl={8}>
        <Card style={{ height: 130 }}>
          <Image src={farmforce} alt="The Arctic University of Norway" />
        </Card>
      </Col>
    </StyledRow>
  );
};

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    margin: 0;
  }
`;
const StyledRow = styled(Row)`
  width: 100%;
  margin-right: auto !important;
  margin-left: auto !important;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 24px;
  height: 100%;
  background: white;
  padding: 32px 48px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  h3 {
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: bold;
  }
`;

export default BusinessCustomers;
